import { render, staticRenderFns } from "./VideoOverlay2.vue?vue&type=template&id=4efb281a&"
import script from "./VideoOverlay2.vue?vue&type=script&lang=js&"
export * from "./VideoOverlay2.vue?vue&type=script&lang=js&"
import style0 from "./VideoOverlay2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoOverlay2.vue"
export default component.exports